import { ChangeDetectionStrategy, Component, ElementRef, NgZone, Renderer2, inject, viewChild } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { debounce, distinctUntilChanged, map, takeUntil, tap } from 'rxjs/operators';
import { BusyIndicatorService } from '../../services/busy-indicator.service';

@Component({
  selector: 'app-busy-indicator',
  templateUrl: './busy-indicator.component.html',
  styleUrls: ['./busy-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BusyIndicatorComponent {
  private _busyIndicatorService = inject(BusyIndicatorService);
  private ngZone = inject(NgZone);
  private renderer = inject(Renderer2);

  private _destroy$: Subject<boolean> = new Subject<boolean>();

  readonly spinnerElement = viewChild<ElementRef>('spinnerElement');

  showIndicator$ = this._busyIndicatorService.operationsInProgress$.pipe(
    distinctUntilChanged(),
    debounce((operations) => (operations > 0 ? timer(0) : timer(200))),
    map((operations) => operations > 0),
    tap((showSpinner) => {
      if (showSpinner) {
        this.showSpinner();
      } else {
        this.hideSpinner();
      }
    }),
  );

  constructor() {
    this.showIndicator$.pipe(takeUntil(this._destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
  }

  private hideSpinner(): void {
    this.ngZone.runOutsideAngular(() => {
      this.renderer.setStyle(this.spinnerElement().nativeElement, 'display', 'none');
    });
  }

  private showSpinner(): void {
    this.ngZone.runOutsideAngular(() => {
      this.renderer.setStyle(this.spinnerElement().nativeElement, 'display', 'block');
    });
  }
}
